<template>
  <div class="segment footer">
    <span style="margin-top:16px;"></span>
    <img src="@/assets/2024/berget-logo-bottom3.png">
    <span style="margin-top:32px;font-size: 17px;">Copyright Berget Events AB 2023. All rights reserved.</span>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
